import { createContext, FC, useEffect, useRef, useState } from "react";
import DrawingContainer from "./DrawingContainer";
import {
  DrawingContextType,
  ImageDetailsType,
  initialStateData,
  OperationType,
  SearchType,
} from "./types";
import { ReactSketchCanvasRef } from "react-sketch-canvas";
export const DrawingContainerContext =
  createContext<DrawingContextType>(initialStateData);
const ActivityComponent: FC = () => {
  const canvasRef = useRef<ReactSketchCanvasRef>(null);
  const [searchParams, setSearchParams] = useState<SearchType>(initialStateData.searchParams);
  const [eraseMode, setEraseMode] = useState(false);
  const [strokeWidth, setStrokeWidth] = useState<number>(5);
  const [eraserWidth, setEraserWidth] = useState<number>(10);
  const [imageUrl, setImageUrl] = useState<string>("");
  const [strokeColor, setStrokeColor] = useState<string>("#000000");
  const [operation, setOperation] = useState<OperationType>("cursor-crosshair");
  const [imageDetails, setImageDetails] = useState<ImageDetailsType | null>(
    null
  );
  useEffect(()=>{
    return ()=>{
      setEraseMode(false)
      setStrokeWidth(0)
      setEraserWidth(0)
      setImageUrl("")
      setStrokeColor(""),
      setOperation("cursor-crosshair"),
      setImageDetails(null)
    }
  },[])
  return (
    <DrawingContainerContext.Provider
      value={{
        canvasRef,
        eraseMode,
        setEraseMode,
        strokeWidth,
        setStrokeWidth,
        eraserWidth,
        setEraserWidth,
        strokeColor,
        setStrokeColor,
        setOperation,
        setImageUrl,
        imageUrl,
        setSearchParams,
        searchParams,
        operation,
        imageDetails,
        setImageDetails,
      }}
    >
      <DrawingContainer />
    </DrawingContainerContext.Provider>
  );
};

export default ActivityComponent;
